export default __webpack_public_path__ + "static/media/harbor.8d91b4d5.jpg";